<template>
  <v-select
    class="select"
    :items="organizations"
    item-value="id"
    item-title="displayName"
    :label="t('common.selectAnItem')"
    v-model="selectedItemId"
  ></v-select>
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';
import { GetOrganizations } from '~/constants/getters';
import { GetOrganizationId } from '~/constants/getters';
import { ChangeActiveOrganization } from '~/constants/actions';
import { useI18n } from 'vue-i18n';

export default {
  name: 'OrganizationSelect',
  setup: function () {
    const store = useStore();
    const { t } = useI18n();

    const organizations = computed(() => store.getters[`authStore/${GetOrganizations}`]);

    const selectedItemId = computed({
      get: () => store.getters[`authStore/${GetOrganizationId}`],
      set: (value) => {
        const selectedOrg = organizations.value.find((org) => org.id === value);
        store.dispatch(`authStore/${ChangeActiveOrganization}`, {
          organizationId: selectedOrg.id,
          auth0Id: selectedOrg.auth0Id,
        });
      },
    });

    return { organizations, selectedItemId, t };
  },
};
</script>

<style scoped lang="scss"></style>
